import { LoaderCircle } from "lucide-react";
import type { ButtonHTMLAttributes, ReactNode } from "react";

import { cn } from "@/lib/utils";

export const PrimaryButton = ({
  busy = false,
  children,
  className,
  disabled,
  ...button
}: {
  busy?: boolean;
  children: ReactNode;
} & ButtonHTMLAttributes<HTMLButtonElement>) => (
  <button
    aria-busy={busy || undefined}
    className={cn(
      "auth-focus auth-press inline-flex h-[52px] w-full items-center justify-center gap-2 rounded-full border-0 bg-coral-500 font-bold text-[19px] text-white tracking-[-0.01em] disabled:cursor-not-allowed disabled:opacity-70",
      className
    )}
    disabled={disabled || busy}
    type="button"
    {...button}
  >
    {busy ? (
      <LoaderCircle
        aria-hidden
        className="size-5 animate-spin motion-reduce:animate-none"
        strokeWidth={1.75}
      />
    ) : null}
    {children}
  </button>
);
